import { Component, OnInit } from '@angular/core';
import {
  ChartConfiguration,
  ChartOptions,
  ChartType,
} from 'chart.js';

@Component({
  selector: 'app-dashboard-second',
  templateUrl: './dashboard-second.component.html',
  styleUrls: ['./dashboard-second.component.css'],
})
export class DashboardSecondComponent {
  public doughnutChart: ChartConfiguration<'doughnut'>['data'] = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        data: [65, 59, 80, 81, 56, 55, 40],
        label: 'Series A',
        borderColor: 'silver',
        backgroundColor: 'transparent',
        borderWidth: 4,
        borderDash: [5, 5],
      },
      {
        data: [40, 55, 56, 81, 80, 59, 65],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
      },
    ],
  };

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        data: [65, 59, 80, 81, 56, 55, 40],
        label: 'Series A',
        borderColor: 'silver',
        backgroundColor: 'transparent',
        borderWidth: 4,
        borderDash: [5, 5],
        tension: 0.4,
      },
      {
        data: [40, 55, 56, 81, 80, 59, 65],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
  };

  //Line Chart 1

  public lineChartData1: ChartConfiguration<'line'>['data'] = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        data: [65, 59, 80, 81, 56, 55, 40],
        borderColor: 'purple',
        backgroundColor: '#0058e9', // Purple color with alpha for fill
        borderWidth: 0,
        pointRadius: 0,
        fill: 'start', // Fill from the bottom
      },
    ],
  };

  public lineChartOptions1: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
    scales: {
      x: {
        display: false, // Hide x-axis
      },
      y: {
        display: false, // Hide y-axis
      },
    },
  };

  //Line Chart 2

  public lineChartData2: ChartConfiguration<'line'>['data'] = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        data: [65, 59, 4, 81, 56, 100, 2],
        borderColor: 'purple',
        backgroundColor: '#0058e9', // Purple color with alpha for fill
        borderWidth: 0,
        pointRadius: 0,
        pointBackgroundColor: '#0058e9',
        fill: 'start', // Fill from the bottom
      },
    ],
  };

  // Doughnut Options

  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false,
    cutout: 80,
  };

  // Doughnut 1
  public doughnutChartDatasets1: ChartConfiguration<'doughnut'>['data']['datasets'] =
    [
      {
        data: [350, 450],
        backgroundColor: ['silver', '#0CAF60'], // Define colors here
        label: 'Series A',
      },
    ];

  // Doughnut 2
  public doughnutChartDatasets2: ChartConfiguration<'doughnut'>['data']['datasets'] =
    [
      {
        data: [350, 450],
        backgroundColor: ['silver', '#FF3A6E'], // Define colors here
        label: 'Series A',
      },
    ];

  // Doughnut 3
  public doughnutChartDatasets3: ChartConfiguration<'doughnut'>['data']['datasets'] =
    [
      {
        data: [350, 450],
        backgroundColor: ['silver', '#0058e9'], // Define colors here
        label: 'Series A',
      },
    ];

  // Pie
  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: false,
    plugins: {
      legend: {
        position: 'right' as const,
      },
    },
  };
  public pieChartLabels = ['Completed', 'Pending', 'Rejected'];
  public pieChartDatasets = [
    {
      data: [500, 100, 100],
      backgroundColor: ['#0CAF60', '#C0A145', '#FF3A6E'],
    },
  ];
  public pieChartPlugins:any = [];

  constructor() {}
}
